<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/z2L86u/tc-custom/9781429954174.jpg?1718106014655" alt="This image is the cover for the book Thin You Within You"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Thin You Within You
      </h1>
      <p class="bookDescription body article font2">
        <p>Diets don't work. The pounds may slide off, but for too many dieters, once the food scales and calorie counters have been put away, the weight returns. Dr. Abraham Twerski, a specialist in addictive behavior, shows that it is not lack of willpower that leads to overeating but an absence of self-esteem. To develop healthy eating habits, a person must first develop a strong sense of self.<br/>With his characteristic upbeat style, Dr. Twerski explains: <br/><br/>-The seemingly illogical compulsion of overeating and its connection to low self-esteem<br/>-The origins and evolutions of low self-esteem and how to identify common problems of a negative self-image<br/>-How to rely on yourself, instead of food, in times of stress, anger, and fear<br/>-How to deal with friends and family members who may contribute to and unhealthy self-image and eating habits <br/>-How to find the courage to change the life-long habits and where to get outside help in the form of therapy and support groups<br/><br/>With Dr. Twerski's straightforward and honest approach, losing weight is redefined as gaining a sense of self and banishing diets forever.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Abraham J. Twerski
      </h2>
      
      <p class="authorDescription body article"><P><B>Abraham J. Twerski M.D.</B>, is a psychiatrist, ordained rabbi, and founder and medical director of the Gateway Rehabilitation Center in Aliquippa, Pennsylvania. He is the author of many books, including <I>When Do the Good Things Start?, Waking Up Just in Time, </I>and <I>"That's not a Fault. . .It's a Character Trait."</I> He lives in Pennsylvania.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d49a75b2